import React, { useCallback, useState } from 'react';
import { isValidEmail } from '../../hooks/useValidation';
import { landJoinUrl } from '../../providers/EnvContextProvider';
import LandLine from './LandLine';
import useAuth from '../../hooks/useAuth';
import './SignUpByEmail.css';
 

const SignUpByEmail = ({withLearnMore = true}) => {
  const [email, setEmail]             = useState('');
  const [showError, setShowError]     = useState(false);
  const [message, setMessage]         = useState('Get your first config item online and live within a minute');
  const [signUpDone, setSignUpDone]   = useState(); // {username:'cigareta-a', passwd: '6uMSH-UIvKOqfZ6x0@1WY3'} {username:'moshe+avdiel76548@gmail.com.edu', passwd: 'blablu-2454-bling-done-23'}
  const {login}                       = useAuth();

  
  // ------ Update Email ------
  //
  const updateEmail = (e) => {    
    const email = encodeURI(e.target.value.trim());
    const isValid = isValidEmail(email, true);
    // console.log('updateEmail:', email, 'isValid:', isValid);
    
    setShowError(!Boolean(isValid) && Boolean(email !== ''));
    if (isValid) {
      setEmail(email);
    }
  };

  // ------ Sign Up Handler -------
  //
  const handleSignUp = () => {        
    if (showError) {
      setMessage('Please enter a valid email address');      
      return;
    }

    if (email === '') {
      setShowError(true);
      setMessage('Email cannot be empty');
      return;
    }

    // Proceed with sign-up
    console.log('Signing up with email:', email);

    const code = Array.from(crypto.getRandomValues(new Uint8Array(6))).map(b => (b % 36).toString(36)).join('');
    const accName = 'my-account-'+code;

    fetch(landJoinUrl, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'landAccountName': accName,
        'landUsername': email,
        'landEmail': email,
        'campId': 'land-004'
      })
    }).then(resp => {
      if (resp.ok) {
        // Google Ads: Conversion Event on Successful SignUp
        window.gtag('event', 'conversion', {
          'send_to': 'AW-17189270506/Fjv5CIeWzdgaEOrnvYRA',
          'value': 1.0,
          'currency': 'ILS',
          'transaction_id': ''
        });

        resp.json().then(doneData => setSignUpDone(doneData));
      }
      else {
        // ... Error 
        console.error('Error SignUp');
      }
    })
    
    // Reset the email input after sign-up
    setEmail('');
    setShowError(false);
    
    // Clear the input field of the email
    const emailInput = document.querySelector('.cta-sube-email');
    if (emailInput) {
      emailInput.value = '';
    }
  }

  // Handle Auth-Login
  const handleAuthLogin = useCallback(() => {
    login(signUpDone.username, signUpDone.passwd);
  },[login, signUpDone]);

  
  // Render

  return (
    <div className='signUpByEmail'>
      {signUpDone && (<div className='cta-sube-done'>
        <div className='cta-sube-done-title'>Welcome! Your account is ready:</div>
        {/* <div className='cta-sube-done-note'>Please save your password securely.</div> */}
        
        <LandLine title='Username' value={signUpDone.username} />
        <LandLine title='Password' value={signUpDone.passwd} />


        <div className='landLogin'>          
          <button className='authLogin' onClick={handleAuthLogin}>
            Login Now
          </button>
        </div>
        <div className='cta-sube-done-nice'>You can change your password later in the settings.</div>
      </div>)}

      {!signUpDone && (
        <div className='signUpByEmail'>
          <div className='cta-sube-note'>{message}</div>

          <div className='cta-sube-form'>
            <input className='cta-sube-email' type='email' onChange={updateEmail} placeholder='Enter your email'/>
            <button className='cta-sube-button' onClick={handleSignUp}>Create Free Account</button>
          </div>

          <div>
            {withLearnMore && (
              <div className='cta-sube-learn-more'>            
                <div className='cta-sube-learn-more-item'> 
                  <a href='https://kiponos.io/about' target='_blank' rel='noopener noreferrer'>Learn More</a> about Kiponos.
                </div>
            </div>
            )}
          </div>

        </div>        
      )}
    </div>
  );
};

export default SignUpByEmail;